import React from "react";
import { Receipt, Settings, Lightbulb, Clock } from "lucide-react";
import { benefits, images } from "../mock";

const iconMap = { Receipt, Settings, Lightbulb, Clock };

const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <div className="text-[12px] tracking-[0.3em] uppercase text-accent2 font-semibold">
              Ihre Vorteile
            </div>
            <h2 className="mt-3 font-display text-[36px] md:text-[46px] leading-tight font-extrabold text-brand-900">
              Unzufrieden mit Ihrer Verwaltung? Wir machen den Wechsel einfach.
            </h2>
            <p className="mt-5 text-brand-700 leading-relaxed">
              Bei HTS Janzen stehen Sie und Ihre Immobilie im Mittelpunkt. Wir wissen, dass Ihre
              Immobilie nicht nur ein Gebäude ist. Sie ist ein Zuhause und eine wichtige
              Investition. Deshalb kümmern wir uns mit Herz und Verstand um jede einzelne Immobilie.
            </p>

            <div className="mt-8 relative rounded-3xl overflow-hidden aspect-[4/3] shadow-xl">
              <img src={images.stats} alt="Wohngebäude bei Sonnenuntergang, betreut von HTS Janzen Hausverwaltung" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-900/70 via-brand-900/10 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <div className="font-display text-2xl font-bold leading-tight">
                  „Wir kümmern uns um Ihre Immobilie. Damit Sie es nicht tun müssen.“
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {benefits.map((b, i) => {
                const Icon = iconMap[b.icon];
                return (
                  <div
                    key={b.title}
                    className={`rounded-3xl p-7 border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                      i % 2 === 0
                        ? "bg-brand-900 text-white border-brand-900"
                        : "bg-brand-50 text-brand-900 border-brand-100"
                    }`}
                  >
                    <div
                      className={`w-12 h-12 rounded-2xl flex items-center justify-center ${
                        i % 2 === 0 ? "bg-white/10 text-white" : "bg-white text-brand-900"
                      }`}
                    >
                      {Icon && <Icon className="w-5 h-5" />}
                    </div>
                    <h3 className="mt-5 font-display font-bold text-xl">{b.title}</h3>
                    <p
                      className={`mt-3 text-[14px] leading-relaxed ${
                        i % 2 === 0 ? "text-brand-100" : "text-brand-700"
                      }`}
                    >
                      {b.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
